import * as React from "react";
import { ShieldCheck, Truck, Award } from "lucide-react";
import { Separator } from "@/components/ui/separator";
const trustPillars = [{
  title: "Personlig Service & Erfarenhet",
  description: "Vi erbjuder skräddarsydd rådgivning med erfarenhet från flera olika branscher för ditt företags unika behov.",
  icon: Award
}, {
  title: "Digitala Lösningar",
  description: "Effektivisera din verksamhet med moderna molnbaserade system som Fortnox och Visma för full kontroll och enkelhet.",
  icon: Truck
}, {
  title: "Trygg Redovisning",
  description: "Vi garanterar en korrekt och trygg hantering av din bokföring, lön och HR enligt gällande svenska regelverk.",
  icon: ShieldCheck
}];
export default function CustomerTrust() {
  return;
}